import { render } from "./FullLayout.vue?vue&type=template&id=538bfcd4"
const script = {}
script.render = render

export default script